import React from 'react';
import Slider from 'react-rangeslider'
// import {Button} from 'react-bootstrap';
import cssClasses from './ProgressBar.css'
import {MdPlayCircleOutline} from 'react-icons/md'
import {FaStopCircle, FaPauseCircle} from 'react-icons/fa'

let timer;

const debounceChange = (value, callback) => {
    if (timer)
        clearTimeout(timer);
    timer = setTimeout(() => callback(value), 100);
};

const progressBar = (props) => {
    let playingState = <button variant="" className={cssClasses.SliderBtn} onClick={props.onPauseAudio}><FaPauseCircle/>
    </button>;
    if (props.playingStatus === 'PAUSED' || props.playingStatus === 'STOPPED') {
        playingState =
            <button variant="" className={cssClasses.SliderBtn} onClick={props.onPlayAudio}><MdPlayCircleOutline/>
            </button>
    }
    return (
        <div className={cssClasses.SliderDiv} style={props.style}>
            {playingState}
            <button variant="" className={cssClasses.SliderBtn} onClick={props.onStopAudio}><FaStopCircle/></button>
            <Slider
                className={cssClasses.Slider}
                min={0}
                max={props.audioLength}
                step={1}
                value={props.position}
                onChange={(value) => {
                    debounceChange(value, (val) => {
                        props.onProgressBarUpdate(val);
                    })
                }}
            />
        </div>
    );
}

export default progressBar;